import { useState, type FormEvent } from "react";
import { heroBg } from "@/mocks/comicData";

interface HeroProps {
  onSearch: (query: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSearch(keyword);
    document.getElementById("ranking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative flex min-h-[92vh] w-full items-center justify-center overflow-hidden">
      <img
        src={heroBg}
        alt="动漫之家漫画网 - 灯火通明的漫画都市"
        title="动漫之家漫画网 排行榜与热门推荐"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-background-50"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-20 text-center md:px-6">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-100 backdrop-blur">
          <i className="ri-flashlight-fill text-accent-400"></i>
          每日更新 · 高分榜单 · 独家汉化
        </span>
        <h1 className="font-heading text-3xl font-bold leading-tight text-white md:text-6xl">
          找到下一部
          <span className="mx-2 text-accent-400">值得熬夜</span>
          追完的漫画
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          聚合动漫之家漫画网排行榜高分作品、完结漫画与分类大全，从热血、恋爱到悬疑国风，
          一站式定位你想看的佳作，开启属于你的追漫之旅。
        </p>

        <form
          onSubmit={handleSubmit}
          className="mt-9 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-50 sm:p-1.5"
        >
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画名 / 类型 / 作者，如：热血、风起苍岚传"
              aria-label="搜索漫画"
              className="w-full rounded-full bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 shadow-sm outline-none placeholder:text-foreground-400 sm:bg-transparent sm:py-2.5 sm:shadow-none"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:py-2.5"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a href="#ranking" className="whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2 text-sm text-background-50 backdrop-blur transition-colors hover:border-background-50/60 hover:bg-background-50/10">
            <i className="ri-trophy-line mr-1.5"></i>看排行榜
          </a>
          <a href="#completed" className="whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2 text-sm text-background-50 backdrop-blur transition-colors hover:border-background-50/60 hover:bg-background-50/10">
            <i className="ri-check-double-line mr-1.5"></i>完结佳作
          </a>
          <a href="#fansub" className="whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2 text-sm text-background-50 backdrop-blur transition-colors hover:border-background-50/60 hover:bg-background-50/10">
            <i className="ri-translate-2 mr-1.5"></i>独家汉化
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-2xl grid-cols-3 gap-4 border-t border-background-50/20 pt-8">
          {[
            { num: "12,000+", label: "收录漫画" },
            { num: "26 个", label: "在线分类" },
            { num: "2,800 万", label: "读者追更" },
          ].map((s) => (
            <div key={s.label} className="flex flex-col items-center">
              <dt className="font-heading text-2xl font-bold text-white md:text-3xl">{s.num}</dt>
              <dd className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}